import React from 'react';
import { IconProps } from '../../types/icons';
import './icon.scss';

const PlaneTakeOffIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="planetakeofficon"
      viewBox="0 0 100 125"
    >
      <path d="M90.233,23.913l-0.015-0.025c-3.521-6.032-11.347-8.18-17.458-4.784l-12.39,6.927L41.337,15.562  c-3.97-2.184-8.824-2.046-12.665,0.354l-7.263,4.54c-0.773,0.485-1.286,1.296-1.389,2.205c-0.105,0.908,0.211,1.815,0.858,2.461  l14.742,14.742l-6.483,3.623l-7.474-4.982c-1.008-0.671-2.32-0.671-3.328,0l-9,6c-0.709,0.472-1.184,1.223-1.304,2.065  c-0.123,0.842,0.117,1.698,0.662,2.351l8.531,10.236c4.668,5.599,12.572,7.432,19.228,4.46l47.862-21.374  C91.348,39.121,94.108,30.562,90.233,23.913z M81.872,36.764L34.004,58.139c-4.213,1.881-9.22,0.719-12.17-2.824l-6.393-7.67  L20,44.605l7.336,4.891c0.938,0.625,2.145,0.669,3.129,0.123l11.546-6.454c0.82-0.458,1.377-1.276,1.506-2.208  c0.129-0.93-0.185-1.868-0.85-2.533l-14.88-14.88l4.063-2.54c2.007-1.25,4.529-1.318,6.595-0.186L57.482,31.29  c1.825,1.002,4.002,0.992,5.815-0.022l12.384-6.923c3.27-1.824,7.468-0.668,9.357,2.575l0.012,0.018  C87.131,30.506,85.661,35.081,81.872,36.764z" fill={fill || '#7E8A96'} />
      <path d="M80,83c0,1.657-1.342,3-3,3H23c-1.658,0-3-1.343-3-3s1.342-3,3-3h54C78.658,80,80,81.343,80,83z" fill={fill || '#7E8A96'} />
    </svg>
  );
};

export default PlaneTakeOffIcon;
